<div class="report">
  <div class="close-report row no-gutters">
    <button id="close-report" class="close-report" (click)="closeReport()">
      ✕
    </button>
  </div>
  <div class="report-text row no-gutters custom-scrollbar">
    <p *ngFor="let paragraph of reportText">
      {{ paragraph }}
    </p>
  </div>
  <div class="row no-gutters footer">
    <div class="col sign-time">Report signed at: {{ signTime }}</div>
    <div class="col copy-report-section">
      <button
        mat-stroked-button
        type="button"
        id="copy-report"
        class="copy-report"
        (click)="copyReport()"
      >
        Copy to Clipboard
      </button>
    </div>
  </div>
</div>
